import { render, staticRenderFns } from "./MaterialTargets.vue?vue&type=template&id=6ecf873a&scoped=true&"
import script from "./MaterialTargets.vue?vue&type=script&lang=js&"
export * from "./MaterialTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf873a",
  null
  
)

export default component.exports